import { adminApi } from "../apiAdmin";
import type { TalentEmailDays, TalentEmailReport } from "../types/talentEmails";

// Admin → Growth → Talent emails: each talent lifecycle email's sends,
// delivery, taps and what talent did next (server GET /admin/talent-emails).
export function getTalentEmailReport(days: TalentEmailDays = 30): Promise<TalentEmailReport> {
  return adminApi.get<TalentEmailReport>("/talent-emails", { params: { days } }).then((r) => r.data);
}
